var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeafSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 100,
      height: 100
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n     .line-plant2-pot {animation:line-plant2-pot 4s -2.5s infinite; stroke-dasharray: 140; stroke-dashoffset: 140;}\n     .line-plant2-plant {animation:line-plant2-plant 4s -2.5s infinite; stroke-dasharray: 140; stroke-dashoffset: 140;}\n     @keyframes line-plant2-pot {\n         20%{stroke-dashoffset: 140;}\n         60%{stroke-dashoffset: 0;}\n         100%{stroke-dashoffset: 0;}\n     }\n     @keyframes line-plant2-plant {\n         45%{stroke-dashoffset: 140;}\n         90%{stroke-dashoffset: 0;}\n         100%{stroke-dashoffset: 0;}\n     }\n     @media (prefers-reduced-motion: reduce) {\n         .line-plant2-pot, .line-plant2-plant {\n             animation: none;\n         }\n     }\n    ")), /*#__PURE__*/React.createElement("g", {
    className: "line-plant2-plant",
    style: {
      animationDuration: "3s"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill2",
    d: "M63.5 37.9849C59 42.4849 51.5 41.4849 51.5 41.4849C51.5 41.4849 51 34.4849 54.5 30.9849C57.2593 28.2256 64.0585 26.3986 66.8128 25.7488C67.427 25.604 67.9896 26.0703 67.9385 26.6993C67.7428 29.1098 66.9242 34.5606 63.5 37.9849Z",
    fill: "rgba(255,174,171,1)",
    strokeWidth: "2px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke2",
    d: "M51.5 41.4849C51.5 41.4849 59 42.4849 63.5 37.9849C66.9242 34.5606 67.7428 29.1098 67.9385 26.6993C67.9896 26.0703 67.427 25.604 66.8128 25.7488C64.0585 26.3986 57.2593 28.2256 54.5 30.9849C51 34.4849 51.5 41.4849 51.5 41.4849ZM51.5 41.4849L59.5 33.4849",
    stroke: "rgba(223,83,78,1)",
    strokeWidth: "2px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill2",
    d: "M56.8416 20.0209C56.8416 26.3849 50.8312 30.9811 50.8312 30.9811C50.8312 30.9811 45.5279 26.3849 45.5279 21.4351C45.5279 17.5329 49.0438 11.4332 50.5319 9.02626C50.8637 8.48951 51.5913 8.42144 52 8.90231C53.5661 10.7451 56.8416 15.1783 56.8416 20.0209Z",
    fill: "rgba(255,174,171,1)",
    strokeWidth: "2px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stroke2",
    d: "M50.8312 30.9811C50.8312 30.9811 56.8416 26.3849 56.8416 20.0209C56.8416 15.1783 53.5661 10.7451 52 8.90231C51.5913 8.42144 50.8637 8.48951 50.5319 9.02626C49.0438 11.4332 45.5279 17.5329 45.5279 21.4351C45.5279 26.3849 50.8312 30.9811 50.8312 30.9811ZM50.8312 30.9811L50.8312 19.6674",
    stroke: "rgba(223,83,78,1)",
    strokeWidth: "2px"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fill2",
    d: "M38 37.9849C44 43.4849 50 41.4849 50 41.4849C50 41.4849 52 35.9849 47 30.9849C42.9582 26.943 36.6292 25.8417 34.352 25.5681C33.8618 25.5092 33.4296 25.8402 33.3849 26.3318C33.2007 28.358 33.2597 33.6396 38 37.9849Z",
    fill: "rgba(255,174,171,1)",
    strokeWidth: "2px"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "stroke2",
    d: "M50 41.4849C50 41.4849 44 43.4849 38 37.9849C33.2597 33.6396 33.2007 28.358 33.3849 26.3318C33.4296 25.8402 33.8618 25.5092 34.352 25.5681C36.6292 25.8417 42.9582 26.943 47 30.9849C52 35.9849 50 41.4849 50 41.4849ZM50 41.4849L44 35.4849",
    stroke: "rgba(223,83,78,1)",
    strokeWidth: "2px"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "stroke2",
    d: "M51 28.4849V55.9849",
    stroke: "rgba(223,83,78,1)",
    strokeWidth: "2px"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "line-plant2-pot",
    style: {
      animationDuration: "3s"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fill1",
    d: "M67.5 54.9849L66.5256 92.0112C66.5114 92.553 66.068 92.9849 65.526 92.9849H34.474C33.932 92.9849 33.4886 92.553 33.4744 92.0112L32.5 54.9849H30C29.4477 54.9849 29 54.5371 29 53.9849V48.9849C29 48.4326 29.4477 47.9849 30 47.9849H70C70.5523 47.9849 71 48.4326 71 48.9849V53.9849C71 54.5371 70.5523 54.9849 70 54.9849H67.5Z",
    fill: "rgba(241,229,229,1)",
    strokeWidth: "2px"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "stroke1",
    d: "M67.5 54.9849L66.5256 92.0112C66.5114 92.553 66.068 92.9849 65.526 92.9849H34.474C33.932 92.9849 33.4886 92.553 33.4744 92.0112L32.5 54.9849M67.5 54.9849H70C70.5523 54.9849 71 54.5371 71 53.9849V48.9849C71 48.4326 70.5523 47.9849 70 47.9849H30C29.4477 47.9849 29 48.4326 29 48.9849V53.9849C29 54.5371 29.4477 54.9849 30 54.9849H32.5M67.5 54.9849H32.5",
    stroke: "rgba(212,147,147,1)",
    strokeWidth: "2px"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "stroke1",
    d: "M37.5 88.4849H48.5",
    stroke: "rgba(212,147,147,1)",
    strokeWidth: "2px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafSpinner);
export default __webpack_public_path__ + "static/media/leaf-spinner.a4b4464171419d921b760daf98549588.svg";
export { ForwardRef as ReactComponent };